export const buttons = {
    undo : "Undo",
    submit : "Submit"
}

export const labels = {
    remarks : "Remarks",
    undo_alloted_vendor : "Undo Alloted Vendor"
}